import type { LVLlinkidCurriculum, LVLlinkidGoalList } from '../types/contentApiTypes';

export const flattenAndExtractCurriculaItems = (
  curr: LVLlinkidCurriculum | LVLlinkidGoalList,
  itemsMap = {},
  readOrder = undefined,
) => {
  const { children, ...childlessCurr } = curr;
  itemsMap[curr.href] = {
    ...childlessCurr,
    childrenHrefs: children?.map((e) => e.href),
    readOrder,
  };
  children?.forEach((c, index) => {
    flattenAndExtractCurriculaItems(c, itemsMap, index);
  });
  return itemsMap;
};
